import { v4 as uuidv4 } from 'uuid';
/**
 * Media 再生/停止
 */
const toggleMediaPlay = (id: string) => {
  const a = document.getElementById(id) as HTMLMediaElement;
  if (a.paused || a.ended) {
    a.play();
  } else {
    a.pause();
  }
};

export const replaceAudioElement = () => {
  document.querySelectorAll('audio').forEach((e) => {
    if (e.style.display === 'none') {
      return;
    }
    if (!e.id) {
      e.id = uuidv4();
    }
    const viewText = (e.textContent ? e.textContent : 'PLAY');
    e.style.display = 'none';
    const container = document.createElement('div');
    container.classList.add('audio-hidden-controls');
    const a = document.createElement('a');
    a.classList.add('audio-anchor');
    a.addEventListener('click', () => { toggleMediaPlay(e.id); });
    a.innerHTML = `<span>${viewText}</span>`;
    container.appendChild(a);
    e.after(container);
  });
};

export default toggleMediaPlay;
